"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircle, Info, Warning, WarningCircle, } from "@phosphor-icons/react";
import * as BaseAlert from "./BaseAlert";
const IconTypes = {
    SUCCESS: "success",
    ERROR: "error",
    INFO: "info",
    WARNING: "warning",
};
const AlertIcon = ({ type, className }) => {
    const iconProps = {
        weight: "duotone",
        className,
    };
    switch (type) {
        case IconTypes.SUCCESS:
            return _jsx(CheckCircle, Object.assign({}, iconProps));
        case IconTypes.WARNING:
            return _jsx(Warning, Object.assign({}, iconProps));
        case IconTypes.ERROR:
            return _jsx(WarningCircle, Object.assign({}, iconProps));
        default:
            return _jsx(Info, Object.assign({}, iconProps));
    }
};
export const Alert = (_a) => {
    var { type, title, description, children } = _a, props = __rest(_a, ["type", "title", "description", "children"]);
    return (_jsxs(BaseAlert.Root, Object.assign({ type: type }, props, { children: [_jsx(BaseAlert.Icon, { asChild: true, children: _jsx(AlertIcon, { type: type }) }), _jsxs(BaseAlert.Content, { children: [_jsx(BaseAlert.Title, { children: title || children }), description && (_jsx(BaseAlert.Description, { children: description }))] })] })));
};
//# sourceMappingURL=Alert.js.map